<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            @if (_context.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Nom</mat-label>
                        <input matInput data-input-displayName type="text" formControlName="displayName" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Compte</mat-label>
                        <input matInput data-input-account type="text" formControlName="account" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Email</mat-label>
                        <input matInput data-input-email type="text" formControlName="email" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Téléphone</mat-label>
                        <input matInput data-input-phoneNumber type="text" formControlName="phoneNumber" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Mobile</mat-label>
                        <input matInput data-input-phoneNumber type="text" formControlName="mobileNumber" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Fax</mat-label>
                        <input matInput data-input-faxNumber type="text" formControlName="faxNumber" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Langue</mat-label>
                        <input matInput data-input-faxNumber type="text" formControlName="culture" autocomplete="off" />
                    </mat-form-field>
                </div>
            }

            <div class="form-item">
                <mat-form-field>
                    <mat-label>Rôles</mat-label>
                    <mat-select data-select-roles formControlName="roles" multiple required #roleselect>
                        @for (role of roles; track role) {
                            <mat-option data-select-listing-type-option [value]="role.id">
                                {{ role.name }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.roles?.required && (formGroup.controls['roles']?.dirty || formGroup.controls['roles'].touched)) {
                        <mat-error data-input-role-error>Le champ 'Rôles' est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid || formValuesChanges === false || userRolesModifyRight === false"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled || userRolesModifyRight === false }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
